// Exact colors from the HTML design
export const C = {
  gold: '#D4A847', gold2: '#F0C96A', goldDim: '#6B4E1A',
  bg: '#080810', bg2: '#0D0D1A', bg3: '#13132A', bg4: '#1A1A35',
  border: '#1E1E3A', text: '#EDE8D8', text2: '#9B94A8',
  accent: '#5B7FD4', red: '#C94A4A', green: '#4A9E6A', purple: '#8B5BD4',
};

export const css = {
  finput: {
    width: '100%', background: C.bg3, border: `1px solid ${C.border}`,
    borderRadius: 12, padding: '13px 16px', color: C.text,
    fontSize: 14, outline: 'none', transition: 'border-color .2s, box-shadow .2s',
  },
  chip: {
    background: C.bg3, border: `1px solid ${C.border}`, borderRadius: 20,
    padding: '8px 14px', color: C.text2, fontSize: 12, cursor: 'pointer',
    transition: 'all .2s', whiteSpace: 'nowrap', fontFamily: 'Cairo, sans-serif',
  },
  chipSel: {
    background: 'rgba(212,168,71,.1)', borderColor: C.gold, color: C.gold,
  },
  card: {
    background: C.bg2, border: `1px solid ${C.border}`,
    borderRadius: 16, padding: 22, marginBottom: 14,
  },
  cardTitle: {
    fontFamily: 'Amiri, serif', fontSize: 16, color: C.gold,
    marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10,
  },
  btnPrimary: {
    width: '100%', background: 'linear-gradient(135deg, #8B6420, #D4A847)',
    border: 'none', borderRadius: 14, padding: 15, color: '#0D0A00',
    fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 22,
    transition: 'all .25s', letterSpacing: .5, fontFamily: 'Cairo, sans-serif',
  },
  btnBack: {
    width: '100%', background: 'none', border: `1px solid ${C.border}`,
    borderRadius: 14, padding: 11, color: C.text2, fontSize: 13,
    cursor: 'pointer', marginTop: 8, transition: 'all .2s', fontFamily: 'Cairo, sans-serif',
  },
  badge: {
    background: 'rgba(212,168,71,.08)', border: `1px solid ${C.goldDim}`,
    borderRadius: 5, padding: '2px 7px', fontSize: 10, color: C.text2,
    fontFamily: 'Cairo, sans-serif',
  },
  ntag: {
    background: 'rgba(212,168,71,.08)', border: `1px solid ${C.goldDim}`,
    borderRadius: 20, padding: '2px 9px', fontSize: 11, color: C.gold,
  },
  quote: {
    background: C.bg3, border: `1px solid ${C.border}`,
    borderRight: `3px solid ${C.goldDim}`, borderRadius: 12,
    padding: '16px 18px', marginBottom: 16,
  },
  quoteText: {
    fontFamily: 'Amiri, serif', fontSize: 15, color: C.gold2,
    lineHeight: 1.8, fontStyle: 'italic',
  },
  numBtn: {
    background: C.bg3, border: `1px solid ${C.border}`, borderRadius: 11,
    padding: '10px 6px', cursor: 'pointer', textAlign: 'center',
    transition: 'all .2s', color: C.text, fontFamily: 'Cairo, sans-serif',
  },
  numBtnSel: {
    background: 'rgba(212,168,71,.1)', borderColor: C.gold,
    boxShadow: '0 0 12px rgba(212,168,71,.15)',
  },
  textarea: {
    width: '100%', background: C.bg3, border: `1px solid ${C.border}`,
    borderRadius: 12, padding: '14px 16px', color: C.text,
    fontSize: 14, resize: 'vertical', minHeight: 96, lineHeight: 1.65,
    outline: 'none', transition: 'border-color .2s', fontFamily: 'Cairo, sans-serif',
  },
  rcard: {
    background: C.bg2, borderRadius: 14, padding: '16px 18px',
    marginBottom: 12, border: `1px solid ${C.border}`,
    borderRight: `3px solid ${C.gold}`,
  },
};
